import { useRef, useState } from "react";

import { runForAtLeast } from "../utils/run-for-at-least";

// A refetch served from a warm cache or a fast network resolves within a frame: without a floor,
// the pending state would flash too briefly for the user to notice the click was taken into account.
const MIN_PENDING_MS = 600;

export const usePendingAction = <Args extends unknown[]>(action: ((...args: Args) => unknown) | undefined) => {
  const [isPending, setIsPending] = useState(false);
  const pendingRef = useRef(false);

  const run = (...args: Args) => {
    if (pendingRef.current || !action) return;
    pendingRef.current = true;
    setIsPending(true);
    void runForAtLeast(MIN_PENDING_MS, () => action(...args)).finally(() => {
      pendingRef.current = false;
      setIsPending(false);
    });
  };

  return { isPending, run };
};
